<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-2 pt-5 pt-md-8 bg-gradient-info">
    </base-header>

    <b-container fluid class="mt-5">
      <div class="container-fluid py-4 bg-white mb-5">
        <div v-show="loading" class="mt-3">
          <Loading />
        </div>
        <div class="row">
          <div class="col-md-3 border-right">
            <div class="d-flex flex-column align-items-center text-center p-3 py-5"><img class="rounded-circle mt-5"
                width="150px"
                src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg">
              <span class="font-weight-bold">{{ tracer.data_alumni.nama_lengkap }}</span><span class="text-black-50">{{ tracer.data_alumni.npm }}</span><span> </span>
            </div>

          </div>

          <div class="col-md-9 border-right">
            <div class="p-3">
              <div class="card p-3">
                <div class="card-header pb-0">
                  <div class="row">
                    <h2 class="card-header d-flex justify-content-between align-items-center">
                      Data Profil Lulusan
                    </h2>
                  </div>
                </div>
                <div class="bg-white mt-5">
                  <b-tabs content-class="mt-3" fill>
                    <b-tab title="Alumni" active>
                      <table class="table align-items-center justify-content-center mb-0 mt-5">
                        <tbody>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Fakultas</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.nm_fakultas }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Prodi</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.nm_program_studi }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Angkatan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.angkatan }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Tanggal Lulus</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.tanggal_lulus }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Tanggal Wisuda</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.tanggal_wisuda }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">IPK</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.ipk }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Pembiayaan Kuliah</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.pembiayaan_kuliah }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Jenis Kelamin</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.jenis_kelamin }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Tempat Lahir</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.tmpt_lahir }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Tanggal Lahir</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.tgl_lahir }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Agama</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.agama }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Email</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.email }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">NIK</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.nik }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">NPWP</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.npwp }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">No Telp</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_alumni.tlpn_hp }}</h6> </div> </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-tab>
                    <b-tab title="Domisili">
                     <table class="table align-items-center justify-content-center mb-0 mt-5">
                        <tbody>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Tempat Tinggal</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_domisili.nm_wil }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Jalan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_domisili.jln }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Kecamatan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_domisili.nm_dsn }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Kelurahan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_domisili.ds_kel }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">RT</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_domisili.rt }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">RW</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_domisili.rw }}</h6> </div> </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-tab>
                    <b-tab title="Hasil Tracer">
                      <table v-if="bekber" class="table align-items-center justify-content-center mb-0 mt-5">
                        <tbody>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">No Urut Pengisisan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">Pengisian Ke- {{ tracer.data_tracer.no_pengisian }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Periode Pengisisan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.id_thn_ajaran }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Waktu Pengisian</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.wkt_pengisian }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Status Lulusan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.status_lulusan }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Bidang Pekerjaan/Usaha</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.nm_bid_kerja }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Level Perusahaan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.level_perusahaan }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Jenis Tempat Bekerja</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.jns_tmpt_bekerja }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Nama Tempat Bekerja</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.nm_tmpt_bekerja }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Wilayah Tempat Bekerja</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.wilayah }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Status Jabatan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.status_jabatan }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Pendapatan Perbulan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.income_per_bln }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Jenis Jalur Daftar</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.nm_jns_jalur_kerja }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Total Instansi dilamar</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.total_instansi_dilamar }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Total Respon Perusahaan</h6>  </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.respon_perusahaan }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Total Panggilan Wawancara</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.wawancara }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Hubungan Bidang Pekerjaan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.hub_bidang_kerja }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Tingkat Kesesuaian Pendidikan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.tkt_kesesuaian }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Alasan Tidak Sesuai</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.alasan_tidak_sesuai }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Bekerja/Berwirausaha Sebelum Wisuda ?</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.a_kerja_sblm_lulus }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Berapa bulan Sebelum/Sesudah Wisuda?</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.wkt_tunggu }}</h6> </div> </td>
                          </tr>
                        </tbody>
                      </table>
                      <table v-if="lanjutStudi" class="table align-items-center justify-content-center mb-0 mt-5">
                        <tbody>
                         <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">No Urut Pengisisan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">Pengisian Ke- {{ tracer.data_tracer.no_pengisian }}</h6> </div> </td>
                          </tr>
                         <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Periode Pengisisan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.id_thn_ajaran }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Waktu Pengisian</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.wkt_pengisian }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Status Lulusan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.status_lulusan }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Wilayah Lanjut Studi</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.wilayah }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Nama PT Lanjut Studi</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.nm_pt_lnjt }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Nama Prodi Lanjut Studi</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.nm_prodi_lnjt }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Waktu Mulai Studi</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.wkt_masuk }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Apakah aktif cari kerja 4 minggu terakhir?</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.c_kerja_terakhir }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Alasan Lanjut Studi?</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.ket }}</h6> </div> </td>
                          </tr>
                          </tbody>
                      </table>
                      <table v-if="tidakBekbeLanjut" class="table align-items-center justify-content-center mb-0 mt-5">
                        <tbody>
                         <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">No Urut Pengisisan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">Pengisian Ke- {{ tracer.data_tracer.no_pengisian }}</h6> </div> </td>
                          </tr>
                         <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Periode Pengisisan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.id_thn_ajaran }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Waktu Pengisian</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.wkt_pengisian }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Status Lulusan</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.status_lulusan }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Apakah aktif cari kerja 4 minggu terakhir?</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.c_kerja_terakhir }}</h6> </div> </td>
                          </tr>
                          <tr>
                            <td> <div class="d-flex px-2"> <div class="my-auto"> <h6 class="mb-0 text-sm">Alasan Tidak Bekerja/Berwirausaha/Lanjut Studi?</h6> </div> </div> </td>
                            <td> <p class="text-sm font-weight-bold mb-0">:</p> </td>
                            <td> <div class="my-auto"> <h6 class="mb-0 text-sm">{{ tracer.data_tracer.ket }}</h6> </div> </td>
                          </tr>
                          </tbody>
                      </table>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
  import BaseHeader from "@/components/admin/BaseHeader";
  import SurveyService from '@/services/survey.service';
  import Loading from "@/components/Loading.vue";

  export default {
    name: "Alumni",
    components: {
      BaseHeader,
      Loading
    },
    data() {
      return {
        id_alumni : this.$route.params.id_alumni,
        id_tracer : this.$route.params.id_tracer,
        tracer: {
          data_alumni: {},
          data_domisili: {},
          data_tracer: {},
        },
        loading: false
      };
    },
    computed: {
      bekber() {
        if (this.tracer.data_tracer.status_lulusan == 'Bekerja' || this.tracer.data_tracer.status_lulusan == 'Berwirausaha') {
          return this.tracer.data_tracer.status_lulusan;
        }
        return false;
      },
      lanjutStudi() {
        if (this.tracer.data_tracer.status_lulusan == 'Melanjutkan Studi') {
          return this.tracer.data_tracer.status_lulusan;
        }
        return false;
      },
      tidakBekbeLanjut() {
        if (this.tracer.data_tracer.status_lulusan == 'Tidak Bekerja') {
          return this.tracer.data_tracer.status_lulusan;
        }
        return false;
      },
    },
    mounted() {
      this.getHasil();
    },
    methods: {
      getHasil() {
        this.loading = true;
        SurveyService.showHasilTracer(this.id_alumni, this.id_tracer).then(res => {
          this.tracer = res.data.data;
          if (this.tracer) {
            this.loading = false;
            return;
          }
        }).catch(error => console.error(error));
      },
    }
  };
</script>
<style scoped>
  .padding {
    padding: 20px !important;
  }

  .nav-tabs .nav-link.active {
    border-color: transparent;
    background-color: #fff !important;
    color: #121589 !important;
    border-bottom: 4px solid #121589 !important
  }

  .nav-fill .nav-item .nav-link,
  .nav-justified .nav-item .nav-link {
    width: 100%;
    color: #000
  }

  .nav-tabs .nav-link {
    border-top-left-radius: 0rem !important;
    border-top-right-radius: 0rem !important
  }

  .nav-tabs .nav-link.active {
    border-color: transparent;
    background-color: #60D0FF;
    color: #fff;
    font-weight: 600
  }

  .nav-link:hover {
    border: none
  }

  .nav-link:focus {
    outline: none
  }
</style>
